import { KnownProjectModuleSettingsDtoName } from '@groundfloor-platform/mgmt-service-g-sdk';
import { InboundDryCleaning } from '../../../ui/components/pure/icons/InboundDryCleaning.icon';
import { InboundMail } from '../../../ui/components/pure/icons/InboundMail.icon';
import { InboundParcel } from '../../../ui/components/pure/icons/InboundParcel.icon';
import { LockerpointOrder } from '../../../ui/components/pure/icons/LockerpointOrder.icon';
import { Order } from '../../../ui/components/pure/icons/Order.icon';
import { OutboundMail } from '../../../ui/components/pure/icons/OutboundMail.icon';
import { PeerToPeer } from '../../../ui/components/pure/icons/PeerToPeer.icon';
import { SVGIconComponent } from '../../../ui/components/pure/icons/types';

export const projectModuleToIconMap: Record<KnownProjectModuleSettingsDtoName, SVGIconComponent> = {
  'dry-cleaning': InboundDryCleaning,
  'inbound-mail': InboundMail,
  'inbound-parcel': InboundParcel,
  'outbound-mail': OutboundMail,
  'peer-to-peer': PeerToPeer,
  'click-and-collect': Order,
  'lockerpoint-orders': LockerpointOrder
};
